const ANCHOR_SATURDAY = Date.UTC(2026, 8, 19); // confirmed Black Mountain Saturday; every 14 days from here
const PERIOD = 14 * 86400000;

export function nextBlackMountainDates(count = 2, now = new Date()) {
  const today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
  const periods = Math.max(0, Math.ceil((today - ANCHOR_SATURDAY) / PERIOD));
  return Array.from({ length: count }, (_, i) => new Date(ANCHOR_SATURDAY + (periods + i) * PERIOD));
}

export const formatLong = (d) =>
  d.toLocaleDateString("en-US", { weekday: "long", month: "long", day: "numeric", timeZone: "UTC" });

export const formatShort = (d) =>
  d.toLocaleDateString("en-US", { month: "short", day: "numeric", timeZone: "UTC" });
